import getConfigEntities from '@apps/maha/services/mjson/get_config_entities'
import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class LandingPages extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { formdata, props } = this.props
    const { advisor, form } = formdata
    const { entity } = props
    const { landing_pages } = form
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: landing_pages.map(landing_page => ({
            label: landing_page.title,
            type: 'segment',
            fields: [
              {
                name: `config.landing_pages.${landing_page.id}.variant_id`,
                type: 'hidden',
                value: landing_page.variants[0].id
              },
              {
                label: 't(Theme)', 
                name: `config.landing_pages.${landing_page.id}.theme_id`,
                type: 'dropdown',
                endpoint: `/api/admin/truevail/${entity}/advisors/${advisor.id}/themes`, 
                valueKey: 'id',
                textKey: 'title',
                selectFirst: true
              },
              ...this._getBlocks(landing_page).map(block => ({
                ...block.type === 'button' ? {
                  label: 't(Button)', 
                  name: `config.landing_pages.${landing_page.id}.blocks.${block.id}`,
                  type: 'dropdown',
                  endpoint: `/api/admin/truevail/${entity}/advisors/${advisor.id}/themes`, 
                  valueKey: 'id',
                  textKey: 'title',
                  selectFirst: true
                } : {}
              }))
            ]
          }))
        }
      ]
    }
  }

  _getBlocks(landing_page) {
    const config = this.props[landing_page.id]
    return getConfigEntities(config, (config) => {
      if(config.type === 'button') return true
    })
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(form) {
    const { formdata } = this.props
    this.props.onNext({
      config: {
        ...formdata.config || {},
        ...form.config   
      }
    })
  }

}

//TODO: find matching voice

const mapResources = (props, context) => ({
  ...props.formdata.form.landing_pages.reduce((versions, landing_page) => ({
    ...versions,
    [landing_page.id]: `/api/admin/truevail_template_variants/${landing_page.variants[0].id}/config/versions/published`
  }), {})
})

export default Container(mapResources)(LandingPages)
